import { Cloud } from '@silbo/core';
import { skipToken, useQuery } from '@tanstack/react-query';

/** Un isolement ajouté ou retiré dans la gestion des lits apparaît dans ce délai au plus. */
const REFRESH_INTERVAL_MS = 30_000;

/**
 * Les spécificités d'isolement du patient d'un séjour, depuis une date. Le serveur lit les hébergements pour
 * l'appelant, qui n'y a pas accès.
 */
export const useEncounterIsolationSpecificities = ({ visitId, from }: { visitId?: string; from?: Date }) => {
  const { data } = useQuery({
    queryKey: ['encounter-isolation-specificities', visitId, from?.getTime()],
    queryFn:
      visitId && from
        ? async () => (await Cloud.getEncounterIsolationSpecificities({ visitId, from })).isolationSpecificities
        : skipToken,
    refetchInterval: REFRESH_INTERVAL_MS,
    refetchOnWindowFocus: true,
  });

  return data ?? [];
};
